import { COLORS } from '@/constants';
import styled from 'styled-components';

export const CenteredBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  text-align: center;
  padding: 24px; /* padding: 3 (MUI spacing = 8px * 3) */
  color: ${COLORS.gray};
  margin: 0 auto;
  max-width: 500px;
`;
